import * as z from "zod/v4";

const LinearUserSchema_ = z.object({
  id: z.string(),
  name: z.string(),
  displayName: z.string(),
  email: z.string(),
  active: z.boolean(),
  avatarUrl: z.string().nullable().optional(),
});

export const LinearUserSchema: z.ZodType<LinearUser> = LinearUserSchema_;
export interface LinearUser extends z.infer<typeof LinearUserSchema_> {}

export const getLinearUsers = {
  name: "getLinearUsers" as const,
  input: z.object({}),
  output: z.object({ users: z.array(LinearUserSchema) }),
};
